import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { TrendingUp, X } from "lucide-react";

// Rotating recent-activity nudges (no real data — sales social-proof signal).
// Times are randomized within a believable window on each mount.
const ACTIVITIES = [
  "4N Thailand · Island Escape",
  "5N Bali · Island Adventure",
  "3N Dubai · City Highlights",
  "5N Singapore · Grand SG Tour",
  "4N Vietnam · Halong & Beyond",
  "5N Philippines · Palawan Paradise",
  "4N Malaysia · Genting & Sunway",
  "3N Bali · Ubud Serenity",
  "5N Dubai · Ultimate Emirate",
  "4N Singapore · Sentosa & Safari",
];

function randomMins() {
  return Math.floor(Math.random() * 28) + 4; // 4-31 mins
}

export default function LiveBookingToast() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [idx, setIdx] = useState(0);
  const [mins, setMins] = useState(randomMins());

  useEffect(() => {
    if (dismissed) return undefined;
    // First appearance after 8s
    const showTimer = setTimeout(() => setVisible(true), 8000);
    // Then rotate every 18s
    const rotateTimer = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx((p) => (p + 1) % ACTIVITIES.length);
        setMins(randomMins());
        setVisible(true);
      }, 600);
    }, 18000);
    return () => {
      clearTimeout(showTimer);
      clearInterval(rotateTimer);
    };
  }, [dismissed]);

  if (dismissed) return null;
  if (location.pathname.startsWith("/admin") || location.pathname === "/quote") return null;
  if (!visible) return null;

  return (
    <div
      data-testid="live-booking-toast"
      className="fixed bottom-24 right-6 z-30 bg-white border border-slate-200 shadow-xl pl-4 pr-3 py-3 flex items-center gap-3 max-w-[280px] fade-up"
    >
      <div className="h-8 w-8 bg-[#0B192C] text-[#FF5238] flex items-center justify-center shrink-0">
        <TrendingUp className="h-4 w-4" />
      </div>
      <div className="flex-1 leading-tight">
        <div className="text-[10px] font-bold tracking-[0.15em] uppercase text-[#FF5238]">
          Just booked
        </div>
        <div className="text-xs text-[#0B192C] font-medium mt-0.5">{ACTIVITIES[idx]}</div>
        <div className="text-[10px] text-slate-500 mt-0.5">{mins} minutes ago</div>
      </div>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        className="text-slate-400 hover:text-[#FF5238] shrink-0"
        aria-label="Dismiss"
        data-testid="live-booking-dismiss"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
